import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { TokenCategoryDetailApi } from '@backend/api/stores/TokenCategoryDetailStore'
import { apiFetch, FormError } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<TokenCategoryDetailApi>('/api/stores/tokenCategoryDetail', { fetch: apiFetch })

export const categoryParamAtom = atom('')

export const refreshAtom = atomWithQuery((get) => {
  const category = get(categoryParamAtom)
  return {
    queryKey: ['TokenCategoryDetailStore', category],
    queryFn: async () => {
      const res = await api.refresh.$get({ query: { category } })
      return await res.json()
    },
    enabled: !!category,
  }
})

export const updateTokenAtom = atom(null, async (get, _set, data: { id: string; value: string }) => {
  await api.updateToken.$post({ json: data })
  await get(refreshAtom).refetch()
})

export const addTokenAtom = atom(null, async (get, _set, data: { name: string; value: string; type: string; layer: string; themeId?: string; description?: string }) => {
  if (!data.name.trim()) throw new FormError('请输入 Token 名称')
  if (!data.value.trim()) throw new FormError('请输入 Token 值')
  await api.addToken.$post({ json: data })
  await get(refreshAtom).refetch()
})

export function loader(store: Store, params: { category?: string }) {
  const category = params.category!
  store.set(categoryParamAtom, category)
  store.get(refreshAtom)
  return null
}
